module.exports = __webpack_public_path__ + "static/jooomla-scanning-84e84bcc06185ca058e129f79952c16d.png";